import * as React from 'react'
import { WrappedComponentProps, injectIntl, useIntl } from 'react-intl'
import { Elements, TextButton } from '@tfo/common'
import { ApprovableOrderViewModel } from '../../ViewModels'
import $http from '../../../../utils/$http'
import Instructions from '../../common/instructions/Instructions'
import Attachments from '../../common/attachments/Attachments'
import { Link } from 'react-router-dom'

import './SignatureInformation.scss'

const { Paragraph, ListItem, UnsortedList } = Elements

type SignatureInformationProps = ApprovableOrderViewModel & {}

const SignatureInformation: React.FunctionComponent<SignatureInformationProps &
    WrappedComponentProps> = (props) => {
        const { companyName, canAttachFile } = props
        const intl = useIntl()
        const [needAttachments, setNeedAttachments] = React.useState<boolean>(props.files.length <= 0)
        const [needScrollToSignButton, setNeedScrollToSignButton] = React.useState<boolean>(true)
        const signButtonRef = React.useRef(null)

        const handleAttachmentsChange = (attachments: string[]) => {
            setNeedAttachments(attachments.length <= 0)
            scrollIntoView();
        }

        const scrollIntoView = () => {
            //scrollIntoViewIfNeeded is not a standard method, 
            //but seems to work in chromium browsers. Use that one if available
            //otherwise do scrollIntoView once to prevent "hopping" scrolling
            if(signButtonRef.current.scrollIntoViewIfNeeded) {
                signButtonRef.current.scrollIntoViewIfNeeded(true)
            } 
            else if(needScrollToSignButton) {
                signButtonRef.current.scrollIntoView({ behavior: "smooth", block: "start" })
                setNeedScrollToSignButton(false)
            }
        }

        const startSignature = async () => {
            const signatureLink = await $http.post<{ link: string }>(`signature/${props.orderId}/start`, null)
            window.location.href = signatureLink.link
        }

        return <div className='signature-information'>
            <div className="AboutBackgroundCheck">
                <Paragraph>
                    {
                        props.intl.formatMessage(
                            { id: 'startIndividual.signature.body' },
                            { companyName })
                    }
                </Paragraph>
            </div>
            <div>
                <div className="todo-list">
                    <UnsortedList>
                        <ListItem>{intl.formatMessage({ id: 'startIndividual.signature.body.point1' })}</ListItem>
                        <ListItem>{intl.formatMessage({ id: 'startIndividual.signature.body.point2' })}</ListItem>
                    </UnsortedList>
                    <Paragraph>{intl.formatMessage(
                        { id: 'startIndividual.signature.GdprPolicySummary' },
                        {
                            link: (
                                <a
                                    href={props.intl.formatMessage({ id: 'common.tfoGdprPolicy.link-url' })}
                                    target='_blank' rel="noreferrer">
                                    {props.intl.formatMessage({ id: 'common.tfoGdprPolicy' })}{' '}
                                </a>
                            )
                        })}</Paragraph>
                </div>

                {props.instructions && <Instructions {...props} />}
                <Attachments {...props} onAttachmentsChange={handleAttachmentsChange} highlighted={needAttachments} />
            </div>

            <div className={'IndividualButtons'} >
                <div className='sign-with-scrive' ref={signButtonRef}>
                    <TextButton
                        disabled={needAttachments}
                        onClick={startSignature}
                        className="StartIndividual__TextButton StartIndividual__TextButton--right">
                        {props.intl.formatMessage({ id: 'awaitResponse.signApprovalButton' })}
                    </TextButton>
                    <Paragraph small>
                        {props.intl.formatMessage({ id: 'awaitResponse.signApprovalButton.description' })}
                    </Paragraph>
                </div>
            </div>
            <div className="AboutBackgroundCheck">
                <Paragraph small >
                    {props.intl.formatMessage(
                        { id: 'startIndividual.footer' },
                        {
                            companyName: companyName,
                            link: (
                                <Link to="/faq">
                                    {props.intl.formatMessage({
                                        id: 'startIndividual.link.faq',
                                    })}
                                </Link>
                            ),
                        },
                    )}
                </Paragraph>
            </div>
        </div>
    }

export default injectIntl(SignatureInformation)